import { createAction, props } from '@ngrx/store';
import { ComplianceGroupResponse } from '../../api/models/compliance-group-response.model';
import { FacilityResponse } from '../../api/models/facility-response.model';
import { MatchGroupPermissionsDto } from '../../api/models/match-group-permissions-dto.model';

export const loadMatchGroups = createAction('[MatchGroup Component] Load Match Groups');
export const loadMatchGroupsSuccess = createAction(
    '[Compliance Service API] Load Match Groups Success',
    props<{ response: ComplianceGroupResponse }>()
);
export const loadMatchGroupsFailure = createAction(
    '[Compliance Service API] Load Match Groups Failure',
    props<{ error: any }>()
);

export const loadFacilitySearchResults = createAction(
    '[AddMatchGroup Component] Load Facility Search Result',
    props<{ name: string; facilityOrSystem: string }>()
);
export const clearFacilitySearchResults = createAction('[AddMatchGroup Component] Clear Facility Search Result');
export const loadFacilitySearchResultsSuccess = createAction(
    '[Compliance Service API] Load Facility Search Result Success',
    props<{ response: FacilityResponse }>()
);
export const loadFacilitySearchResultsFailure = createAction(
    '[Compliance Service API] Load Facility Search Result Failure',
    props<{ error: any }>()
);

export const addMatchGroup = createAction(
    '[AddMatchGroup Component] Add Match Group',
    props<{ name: string; facilityIds: number[]; systemIds: number[] }>()
);
export const addMatchGroupSuccess = createAction('[Compliance Service API] Add Match Group Success');
export const addMatchGroupFailure = createAction(
    '[Compliance Service API] Add Match Group Failure',
    props<{ error: any }>()
);

export const updateMatchGroup = createAction(
    '[AddMatchGroup Component] Update Match Group',
    props<{ id: number; name: string; facilityIds: number[]; systemIds: number[]; isStrike: boolean }>()
);
export const updateMatchGroupSuccess = createAction('[Compliance Service API] Update Match Group Success');
export const updateMatchGroupFailure = createAction(
    '[Compliance Service API] Update Match Group Failure',
    props<{ error: any }>()
);

export const deleteMatchGroup = createAction('[MatchGroup Component] Delete Match Group', props<{ id: number }>());
export const deleteMatchGroupSuccess = createAction('[Compliance Service API] Delete Match Group Success');
export const deleteMatchGroupFailure = createAction(
    '[Compliance Service API] Delete Match Group Failure',
    props<{ error: any }>()
);

export const deleteMatchGroupItem = createAction(
    '[MatchGroup Component] Delete Match Group Item',
    props<{ facilityId: number; groupId: number; isStrike: boolean }>()
);
export const deleteMatchGroupItemSuccess = createAction('[Compliance Service API] Delete Match Group Item Success');
export const deleteMatchGroupItemFailure = createAction(
    '[Compliance Service API] Delete Match Group Item Failure',
    props<{ error: any }>()
);

export const getMatchGroupPermissions = createAction('[MatchGroup Component] Get Match Group Permissions');
export const getMatchGroupPermissionsSuccess = createAction(
    '[Compliance Service API] Get Match Group Permissions Success',
    props<{ permissions: MatchGroupPermissionsDto }>()
);
export const getMatchGroupPermissionsFailure = createAction(
    '[Compliance Service API] Get Match Group Permissions Failure',
    props<{ error: any }>()
);
